import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { dxpClient } from "./services/apollo-client";
import { PublicClientApplication, AuthenticationResult, EventType, InteractionRequiredAuthError } from "@azure/msal-browser";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "./provider/ErrorFallback";
import { msalConfig } from "./services/authConfig";
import GlobalContextProvider from "./provider/GlobalContextProvider";
import Loader from "./components/Loader";


let nameOfUser: string = '';
const msalInstance = new PublicClientApplication(msalConfig);

// Default to using the first account if no account is active on page load
if (
  !msalInstance.getActiveAccount() &&
  msalInstance.getAllAccounts().length > 0
) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

const removeMsalEntriesFromsessionStorage = () => {
  // Remove MSAL.js related entries from sessionStorage
  Object.keys(sessionStorage).forEach(key => {
    if (key.startsWith("msal.")) {
      sessionStorage.removeItem(key);
    }
  });
};

msalInstance.addEventCallback(event => {

  const authenticationResult = event.payload as AuthenticationResult;

  // appInsights.trackEvent({
  //   name: 'msal:authenticationResult',
  //   properties: {
  //     eventType: event?.eventType,
  //     interactionType: event?.interactionType,
  //     eventError: event?.error,
  //     userClaims: authenticationResult?.account?.idTokenClaims?.security_roles,
  //     context: authenticationResult?.account?.idTokenClaims?.context,
  //     userEmail: authenticationResult?.account?.idTokenClaims?.email,
  //   },
  // });

  /**
   * Manually remove the msal and b2c entries from the local storage
   * otherwise post login in case of previous 400(EventType.ACQUIRE_TOKEN_FAILURE)
   * the old token is persistent in the store and resend for verification
   * This happens only for WinField users - when domain-hint is "winfieldunited".
   */
  if (
    (event.eventType === EventType.ACQUIRE_TOKEN_FAILURE &&
      // @ts-expect-error types from msal are not considering monitor_window_timeout error
      event.error?.errorCode === 'monitor_window_timeout') ||
    event.error instanceof InteractionRequiredAuthError
  ) {
    removeMsalEntriesFromsessionStorage();

    // fallback to interaction when silent call fails
    return msalInstance.acquireTokenRedirect({
      scopes: ['openid', 'profile', 'offline_access'],
      domainHint: process.env.REACT_APP_WUCA_DOMAIN_HINT
      // domainHint: 'winfieldunited', 
      // process.env.REACT_APP_DOMAIN_HINT,
    });
  }


  if (authenticationResult === null) return;

  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
      event.eventType === EventType.SSO_SILENT_SUCCESS) &&
    authenticationResult.account
  ) {
    msalInstance.setActiveAccount(authenticationResult.account);

    const { idTokenClaims } = authenticationResult.account;

    if (authenticationResult.account.name) {
      sessionStorage.setItem('nameOfUser', authenticationResult.account.name);
    }
    if (idTokenClaims?.security_roles) {
      if (Array.isArray(idTokenClaims?.security_roles) && idTokenClaims.security_roles.length > 0) {
        sessionStorage.setItem('user roles', idTokenClaims.security_roles.join(','));
      }
    }

    // const existingLoginEvent = (window as any).adobeDataLayer.find(
    //   (event: any) => event.event === 'login'
    // );
    (window as any).adobeDataLayer = (window as any).adobeDataLayer || [];
    // if (!existingLoginEvent) {
    (window as any).adobeDataLayer.push({
      event: 'login',
      user: {
        userId: idTokenClaims?.ag2ag,
        userType: idTokenClaims?.user_type,
      },
      securityRoles: idTokenClaims?.security_roles,
    });
    // }
  }
});

// if (
//   process.env.NODE_ENV === 'development' &&
//   process.env.USE_MOCK_SERVER === 'true'
// ) {
//   worker.start({
//     onUnhandledRequest(req: MockedRequest) {
//       // display warning message only for api requests
//       if (req.url.pathname.startsWith('\\api')) {
//         console.warn(
//           'Found an unhandled %s request to %s',
//           req.method,
//           req.url.href,
//         );
//       }
//     },
//   });
// }

// console.log("process.env:", process.env);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <GlobalContextProvider>

      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <App instance={msalInstance} />
      </ErrorBoundary>
      </GlobalContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
